const enhanceQuantity = (quantityRoot) => {
  if (!quantityRoot || quantityRoot.classList.contains('is-enhanced')) {
    return
  }

  const input = quantityRoot.querySelector('input.qty')

  if (!input) {
    return
  }

  const minus = document.createElement('button')
  const plus = document.createElement('button')
  minus.type = 'button'
  plus.type = 'button'
  minus.className = 'quantity__button quantity__button--minus'
  plus.className = 'quantity__button quantity__button--plus'
  minus.setAttribute('aria-label', 'Decrease quantity')
  plus.setAttribute('aria-label', 'Increase quantity')
  minus.textContent = '−'
  plus.textContent = '+'

  quantityRoot.prepend(minus)
  quantityRoot.append(plus)
  quantityRoot.classList.add('is-enhanced')

  const parseValue = () => {
    const raw = parseFloat(input.value || '0')
    return Number.isNaN(raw) ? 0 : raw
  }

  const getStep = () => {
    const raw = input.getAttribute('step')
    const parsed = raw && raw !== 'any' ? parseFloat(raw) : 1
    return Number.isNaN(parsed) ? 1 : parsed
  }

  const getMin = () => {
    const parsed = parseFloat(input.getAttribute('min') || '0')
    return Number.isNaN(parsed) ? 0 : parsed
  }

  const getMax = () => {
    const raw = input.getAttribute('max')

    if (!raw) {
      return Infinity
    }

    const parsed = parseFloat(raw)
    return Number.isNaN(parsed) ? Infinity : parsed
  }

  minus.addEventListener('click', () => {
    const nextValue = Math.max(getMin(), parseValue() - getStep())
    input.value = String(nextValue)
    input.dispatchEvent(new Event('change', { bubbles: true }))
  })

  plus.addEventListener('click', () => {
    const nextValue = Math.min(getMax(), parseValue() + getStep())
    input.value = String(nextValue)
    input.dispatchEvent(new Event('change', { bubbles: true }))
  })
}

const initWooQuantity = () => {
  document.querySelectorAll('.woocommerce .quantity, .product-single__purchase .quantity').forEach(enhanceQuantity)
}

export default initWooQuantity



// WEBPACK FOOTER //
// ./resources/assets/js/components/woo-quantity.js